<template>
  <v-container>
    <v-list>
      <draggable @update="menu_move" handle=".handle">
        <v-list-item
          @click="$emit('product-selected', product)"
          v-for="product in products"
          :key="product.id"
        >
          <v-icon class="handle">mdi-drag-vertical</v-icon>
          <v-checkbox
            transition="slide-x-transition"
            v-model="selectedProducts"
            :value="product.id"
            class="ml-2"
          />
          <v-list-item-avatar>
            <v-img :src="product.image"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title
              :class="{ 'text-decoration-line-through': !product.visibility }"
            >
              {{ product.name }}
            </v-list-item-title>
            <v-list-item-subtitle text-truncate>
              {{ product.description }}
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-icon v-if="product.price > 0">{{
            localizedPrice(product.price)
          }}</v-list-item-icon>
        </v-list-item>
      </draggable>
    </v-list>
    <v-snackbar v-model="selectedProducts.length" flat :timeout="0">
      <v-icon @click="selectedProducts = []" dark>mdi-close</v-icon>
      {{
        $t("{num} products selected", {
          num: selectedProducts.length
        })
      }}

      <v-dialog v-model="deleteProductsDialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            {{ $t("Delete") }}
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline"
              >{{
                $t("Delete {num} products selected", {
                  num: selectedProducts.length
                })
              }}
            </span>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="deleteProductsDialog = false"
              v-text="$t('Cancel')"
            ></v-btn>
            <v-btn
              text
              color="primary"
              @click="deleteProducts()"
              v-text="$t('Delete')"
            ></v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="moveProductsDialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            {{ $t("Move") }}
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">
              {{
                $t("Move {num} products selected to", {
                  num: selectedProducts.length
                })
              }}...</span
            >
          </v-card-title>
          <v-card-text>
            <v-autocomplete
              :items="[...categories, { name: $t('No category'), id: -2 }]"
              item-text="name"
              item-value="id"
              :label="$t('Categories')"
              flat=""
              v-model="targetCategory"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text color="primary" @click="moveProductsDialog = false">
              {{ $t("Cancel") }}
            </v-btn>
            <v-btn text color="primary" @click="moveProductsTo">
              {{ $t("Move") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-snackbar>
  </v-container>
</template>

<script>
import Product from "@/model/product.js";
import draggable from "vuedraggable";
import { firestore } from "@/firebase/firestore"; // TODO: cambiar esto para usarlo en objetos

export default {
  data() {
    return {
      deleteProductsDialog: false,
      moveProductsDialog: false,
      targetCategory: "",
      selectedProducts: []
    };
  },
  props: ["products"],
  computed: {
    categories: function() {
      return this.$store.getters.categories;
    }
  },
  methods: {
    localizedPrice(price) {
      // TODO actually localize
      return parseFloat(price).toFixed(2) + " €";
    },

    moveProductsTo() {
      let updatedCategories = {};
      // New category is updated
      updatedCategories[this.targetCategory] = this.$store.getters.menu.find(
        category => category.id === this.targetCategory
      ).products;
      this.selectedProducts.forEach(productId => {
        let product = this.$store.getters.products.find(
          product => product.id === productId
        );
        if (!updatedCategories[product.category]) {
          let category = this.$store.getters.menu.find(
            category => category.id === product.category
          );
          updatedCategories[category.id] = category.products;
        }
        // Remove product from old category
        updatedCategories[product.category] = updatedCategories[
          product.category
        ].filter(categoryProduct => categoryProduct.id !== product.id);
        updatedCategories[this.targetCategory].push(product);
        product.category = this.targetCategory;
      });

      // Save new indexes
      Object.values(updatedCategories).forEach(categoryProducts => {
        let index = 0;
        categoryProducts.forEach(product => {
          // Save product if selected or index updated
          if (
            product.index !== index ||
            this.selectedProducts.some(productId => product.id === productId)
          ) {
            product.index = index;
            product.save();
          }
          index++;
        });
      });
      this.closeMoveProductsDialog();
    },
    closeMoveProductsDialog() {
      this.selectedProducts = [];
      this.targetCategory = "";
      this.moveProductsDialog = false;
    },

    async deleteProducts() {
      this.$emit("product-selected", null);
      let deletePromises = this.selectedProducts.map(product =>
        new Product({ id: product }).delete()
      );
      this.deleteProductsDialog = false;
      this.selectedProducts = [];
      // try {
      await Promise.all(deletePromises);
      // } catch (error) {
      //   console.log(error);
      // }
    },

    menu_move(value) {
      let products = this.products;
      this.order = [...Array(products.length).keys()];
      // this.wait = true;
      if (value.newIndex >= products.length) {
        var k = value.newIndex - products.length + 1;
        while (k--) {
          this.order.push(undefined);
        }
      }
      this.order.splice(
        value.newIndex,
        0,
        this.order.splice(value.oldIndex, 1)[0]
      );

      let restaurantId = this.$store.getters.restaurant.id;
      let batch = firestore.batch();

      this.order.forEach(function(oldIndex, newIndex) {
        if (products[oldIndex].index != newIndex) {
          let prodRef = firestore
            .collection(`restaurants/${restaurantId}/products`)
            .doc(products[oldIndex].id);
          batch.update(prodRef, { index: newIndex });
        }
      });
      batch.commit();
      return false;
      // this.wait = false;
      // this.menu = this.$store.getters.menu;
    }
  },

  components: { draggable }
};
</script>

<style>
.text-decoration-line-through {
  text-decoration: line-through;
}
</style>
